<template>
	<div class="contentbox">
		<ul class="tabs-ul-list">
            <li v-for="(item, index) in tabName" :key="index">
                <a :class="item.value === selectaVal ? 'active' : ''" @click="tabClick(item.value)">{{item.name}}</a>
            </li>
        </ul>
        <div class="tabs-ul-con" style="padding-top: 30px;">
            <!-- <router-view></router-view> -->
            <app-recharge-gear v-if="selectaVal==1"></app-recharge-gear>
            <app-recharge-plan v-if="selectaVal==2"></app-recharge-plan>
        </div>
	</div>
</template>
<script>
import AppRechargeGear from '@/components/AppRechargeGear'
import AppRechargePlan from '@/components/AppRechargePlan'
export default {
    components: {
        AppRechargeGear,
        AppRechargePlan
	},
    data() {
        return {
            tabName: [
                {
                    value: 1,
                    name: '创建充值档位'
                },{
                    value: 2,
                    name: '充值方案配置'
                },
            ],
            selectaVal:1,
        }
    },
    computed: {},
    watch: {},
    created(){},
    mounted: function() {},
    methods: {
        tabClick (value) {
            // this.$router.push({ path:  path})
            this.selectaVal = value
        }
    }
}
</script>
<style lang="sass">

</style>
